import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [``],
})
export class PageMypageComponent implements OnInit {
    public user: any = null;
    public saving: boolean = false;

    public passwordForm: any = {
        current_password: '',
        new_password: '',
        confirm_password: ''
    };
    public changingPassword: boolean = false;

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow("/access");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("get");
        if (code === 200) {
            this.user = data;
        }
        await this.service.render();
    }

    public async updateProfile() {
        if (!this.user.name) {
            await this.service.modal.error(this.translate.instant('page.mypage.error_name_required'));
            return;
        }

        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("update_profile", {
            name: this.user.name,
            mobile: this.user.mobile || ''
        });

        await this.service.sleep(500);
        this.saving = false;

        if (code === 200) {
            await this.service.modal.success(this.translate.instant('page.mypage.profile_updated'));
        } else {
            await this.service.modal.error(data || this.translate.instant('page.mypage.profile_update_failed'));
        }
        await this.service.render();
    }

    public async changePassword() {
        const { current_password, new_password, confirm_password } = this.passwordForm;

        if (this.user?.has_local_password && !current_password) {
            await this.service.modal.error(this.translate.instant('page.mypage.error_current_password_required'));
            return;
        }
        if (!new_password) {
            await this.service.modal.error(this.translate.instant('page.mypage.error_new_password_required'));
            return;
        }
        if (!this.passwordPolicyValid(new_password)) {
            await this.service.modal.error(this.translate.instant('page.mypage.error_password_min'));
            return;
        }
        if (new_password !== confirm_password) {
            await this.service.modal.error(this.translate.instant('page.mypage.error_password_mismatch'));
            return;
        }

        this.changingPassword = true;
        await this.service.render();

        const { code, data } = await wiz.call("change_password", {
            current_password: current_password,
            new_password: new_password
        });

        await this.service.sleep(500);
        this.changingPassword = false;

        if (code === 200) {
            await this.service.modal.success(this.translate.instant('page.mypage.password_changed'));
            this.passwordForm = { current_password: '', new_password: '', confirm_password: '' };
        } else {
            await this.service.modal.error(data || this.translate.instant('page.mypage.password_change_failed'));
        }
        await this.service.render();
    }

    private passwordPolicyValid(password: string): boolean {
        const value = String(password || '');
        if (value.length < 10) return false;
        const classes = [
            /[a-z]/.test(value),
            /[A-Z]/.test(value),
            /[0-9]/.test(value),
            /[^A-Za-z0-9]/.test(value),
        ];
        return classes.filter(Boolean).length >= 2;
    }
}

export default PageMypageComponent;
